import { APPOINTMENT_STATUS } from "@elixir/types";
import { useQuery } from "@tanstack/react-query";
import { getBusinessAllApts } from "apis";
import { TAppointmentQueueRequestObject } from "../../types/apis";
import { QueueType } from "../../utils/get-appointment-card-prop";
import { useMyAccessProfileV2 } from "./get-my-access-profile";

export function getAppointmentsQueryName({
  clinicId,
  queueType,
  startDate,
  endDate,
}: {
  clinicId?: string;
  queueType?: QueueType;
  startDate?: string;
  endDate?: string;
} = {}) {
  const keyName = ["appointments"];
  if (clinicId) {
    keyName.push(clinicId);
  }
  if (queueType) {
    keyName.push(queueType);
  }
  if (startDate) {
    keyName.push(startDate);
  }
  if (endDate) {
    keyName.push(endDate);
  }

  return keyName;
}

export default function useGetAppointments({
  queueType,
  clinicId,
  startDate,
  endDate,
}: TAppointmentQueueRequestObject) {
  const endDateObj = endDate ? new Date(endDate) : new Date(startDate);
  if (!endDate) {
    endDateObj.setHours(endDateObj.getHours() + 24);
  }
  const endDateString = endDateObj.toISOString();

  const { data: myAccessProfile } = useMyAccessProfileV2();

  return useQuery(
    getAppointmentsQueryName({
      queueType,
      clinicId,
      startDate: startDate,
      endDate: endDateString,
    }),
    async () =>
      // TODO: Use getAppointmentsQueueFn here in the future
      {
        const { apts } = await getBusinessAllApts({
          clinicId,
          startTime: startDate,
          endTime: endDateString,
          docIds: myAccessProfile?.doctors?.map((item) => item.oid) || [],
          status: [
            APPOINTMENT_STATUS.ONGOING,
            APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION,
            APPOINTMENT_STATUS.NO_SHOW,
            APPOINTMENT_STATUS.NO_SHOW_DOCTOR,
            APPOINTMENT_STATUS.NO_SHOW_STAFF,
            APPOINTMENT_STATUS.ABORTED,
            APPOINTMENT_STATUS.COMPLETED,
            APPOINTMENT_STATUS.BOOKED,
            APPOINTMENT_STATUS.PARKED,
            APPOINTMENT_STATUS.CHECKED_IN,
          ],
          getArchived: false,
        });

        return {
          success: true,
          response: {
            apt: apts,
            countResponse: {},
          },
        };
      },
    {
      staleTime: 5 * 60 * 1000,
      refetchInterval: 60 * 1000,
      enabled: !!clinicId && !!myAccessProfile,
    }
  );
}
